import { AssessmentAnswerInterface } from 'app/assessment/models/assessment-answer.model';

export interface AssessmentQuestionInterface {
  id?: number;
  label?: string;
  group?: string;
  groupLabel?: string;
  isMultipleChoice?: boolean;
  imagePath?: string;
  childQuestions?: AssessmentQuestionInterface[];
  childQuestionTriggers?: number[];
  answers?: AssessmentAnswerInterface[];
}

export class AssessmentQuestion implements AssessmentQuestionInterface {
  public id?: number;
  public label?: string;
  public group?: string;
  public groupLabel?: string;
  public isMultipleChoice?: boolean;
  public imagePath?: string;
  public childQuestions?: AssessmentQuestionInterface[];
  public childQuestionTriggers?: number[];
  public answers?: AssessmentAnswerInterface[];

  constructor({
    label = undefined,
    group = undefined,
    groupLabel = undefined,
    isMultipleChoice = undefined,
    imagePath = undefined,
    childQuestions = undefined,
    childQuestionTriggers = undefined,
    answers = undefined,
    }: AssessmentQuestionInterface) {
    this.label = label;
    this.group = group;
    this.groupLabel = groupLabel;
    this.isMultipleChoice = isMultipleChoice;
    this.imagePath = imagePath;
    this.childQuestions = childQuestions;
    this.childQuestionTriggers = childQuestionTriggers;
    this.answers = answers;
  }
}
